/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CheckboxesExpandable from 'shared/ui/components/form-components/CheckboxesExpandable.vue';


const __vue_script__ = {
    name: 'LeaderboardExportModal',

    components: { CheckboxesExpandable },

    props: {
        eventId: {
            type: String,
            required: true,
        },
        leaderboardId: {
            type: String,
            required: true,
        },
        personFields: {
            type: Array,
            required: true,
        },
        leaderboardFields: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            selectedPersonFields: [],
            selectedLeaderboardFields: [],
            downloadUrl: undefined,
            exporting: false,
            fileName: 'Leaderboard export.xlsx',
        };
    },

    mounted() {
        this.selectedPersonFields = this.personFields.reduce((r, d) => {
            if (d.value) { r.push(d.name); }
            return r;
        }, []);
        this.selectedLeaderboardFields = this.leaderboardFields.reduce((r, d) => {
            if (d.value) { r.push(d.name); }
            return r;
        }, []);
    },

    methods: {
        onClose() {
            this.$emit('close');
        },

        async onExport() {
            const fields = [
                ...this.selectedLeaderboardFields,
                ...this.selectedPersonFields,
            ];

            if (!fields.length) {
                return;
            }

            this.exporting = true;

            const result = await this.$services.appScripts.createJobAndWaitForCompletion(this.eventId, 'leaderboard/export-leaderboard', {
                leaderboardId: this.leaderboardId,
                columnsConfig: fields.reduce((r, d) => ({ ...r, [d]: d }), {}),
            }, {
                fileName: this.fileName,
                name: 'Export Leaderboard',
            }).catch(err => {
                console.error(`[LeaderboardExportCell] failed to export ${this.leaderboardId}`, err);
            });

            this.downloadUrl = result?.excelExportDownloadPath;

            if (!this.downloadUrl) {
                console.error('[LeaderboardExportCell] did not return a download path');
                this.$emit('close');
            }

            this.exporting = false;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leaderboard-export-cell-modal modal-wrapper" },
    [
      _c("div", { staticClass: "modal-header" }, [
        _vm.downloadUrl
          ? _c("h3", [_vm._v(_vm._s(_vm.$t("general.download")))])
          : _c("h3", [
              _vm._v(_vm._s(_vm.$t("listings.messages.select_fields"))),
            ]),
      ]),
      _vm.downloadUrl
        ? _c("div", { staticClass: "modal-body" }, [
            _c("a", { attrs: { href: _vm.downloadUrl, target: "_blank" } }, [
              _vm._v(_vm._s(_vm.fileName)),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("checkboxes-expandable", {
                attrs: {
                  label: _vm.$t("listings.messages.person_fields"),
                  name: _vm.$t("listings.messages.person_fields"),
                  options: _vm.personFields,
                  inline: true,
                  itemised: true,
                  showToggler: true,
                },
                model: {
                  value: _vm.selectedPersonFields,
                  callback: function ($$v) {
                    _vm.selectedPersonFields = $$v
                  },
                  expression: "selectedPersonFields",
                },
              }),
              _c("checkboxes-expandable", {
                attrs: {
                  label: _vm.$t("listings.messages.other_fields"),
                  name: _vm.$t("listings.messages.other_fields"),
                  options: _vm.leaderboardFields,
                  inline: true,
                  itemised: true,
                  showToggler: true,
                },
                model: {
                  value: _vm.selectedLeaderboardFields,
                  callback: function ($$v) {
                    _vm.selectedLeaderboardFields = $$v
                  },
                  expression: "selectedLeaderboardFields",
                },
              }),
            ],
            1
          ),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "footer",
          { staticClass: "actions", attrs: { slot: "bottom" }, slot: "bottom" },
          [
            !_vm.exporting
              ? _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm.onClose } },
                  [
                    _vm._v(
                      _vm._s(
                        "" +
                          (_vm.downloadUrl
                            ? _vm.$t("general.close")
                            : _vm.$t("general.cancel"))
                      )
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.exporting && !_vm.downloadUrl
              ? _c(
                  "button",
                  { staticClass: "btn primary", on: { click: _vm.onExport } },
                  [_vm._v(_vm._s(_vm.$t("listings.messages.export")))]
                )
              : _vm._e(),
          ]
        ),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/listings/custom-actions/LeaderboardExportModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__